// extracted by mini-css-extract-plugin
module.exports = {"gridCell":"GridCell_gridCell__308tJ"};